































import Vue, { PropType } from 'vue'
import { TopUpDeal } from '~/utils/interfaces/topup.interface'
export default Vue.extend({
  props: {
    deal: { type: Object as PropType<TopUpDeal>, required: true },
  },
})
